import { THEMES, type DiscoveryPlace, type DiscoveryTheme } from './types';

export interface BookSection {
  readonly theme: DiscoveryTheme;
  readonly title: string;
  readonly found: number;
  readonly entries: readonly { readonly place: DiscoveryPlace; readonly found: boolean }[];
}

export interface Book {
  readonly found: number;
  readonly total: number;
  readonly percent: number;
  readonly sections: readonly BookSection[];
}

/** The book as it reads now: every place under its theme, in the order they were written. */
export function bookOf(
  places: readonly DiscoveryPlace[],
  journal: { has(id: string): boolean }
): Book {
  const sections = (Object.keys(THEMES) as DiscoveryTheme[]).map((theme) => {
    const entries = places
      .filter((place) => place.theme === theme)
      .map((place) => ({ place, found: journal.has(place.id) }));
    return {
      theme,
      title: THEMES[theme],
      found: entries.filter((entry) => entry.found).length,
      entries,
    };
  });
  const found = sections.reduce((sum, section) => sum + section.found, 0);
  return {
    found,
    total: places.length,
    percent: places.length === 0 ? 0 : Math.round((found / places.length) * 100),
    sections,
  };
}
